export const STAFF_PASSWORD_MIN_LENGTH = 6;

/** Shared by password forms and the staff service to keep validation in sync.
 * Staff require length only. Students retain their existing complexity rules.
 * The Edge Function independently enforces the staff policy; parity is tested.
 */
export const passwordRequirements = (
  password: string,
  minimumLength = STAFF_PASSWORD_MIN_LENGTH,
  requireComplexity = false,
) => [
  {
    label: `At least ${minimumLength} characters`,
    isValid: password.length >= minimumLength,
  },
  ...(requireComplexity
    ? [
        {
          label: 'Uppercase and lowercase letters',
          isValid: /[a-z]/.test(password) && /[A-Z]/.test(password),
        },
        { label: 'At least one number', isValid: /\d/.test(password) },
        {
          label: 'At least one special character',
          isValid: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        },
      ]
    : []),
];

export const staffPasswordError = (password: string): string | null =>
  passwordRequirements(password).every((rule) => rule.isValid)
    ? null
    : 'Use at least 6 characters.';
